import { Component } from '@angular/core';

@Component({
  selector: 'app-facebook-icon',
  templateUrl: 'facebook-icon.component.svg',
})
export class FacebookIconComponent {
}

